import React, { createContext, useState, useEffect } from 'react';

//create context
export const ProductContext = createContext();

const ProductProvider = ({ children }) => {
  const [Products, setProducts] = useState([])
  //fetch product
  useEffect(() => {
    const fetchProducts = async () => {
      const response = await fetch('https://fakestoreapi.com/products');
      const data = await response.json()
      setProducts (data)
    };  
    fetchProducts();
  },[])
  return <ProductContext.Provider value={{Products}}>{children}</ProductContext.Provider>;
};

export default ProductProvider;
